import handleSendMessage from "./handleSendMessage";

export const handleCancelProject = async (setIsCancelProjectModalOpen, socket, selectedChatSession, userInfo) =>{

try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/updateChatSessionStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ chatSessionId: selectedChatSession._id, status: 'canceled' }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response from backend:", errorText);
      throw new Error('Failed to update chatSession status');
    }

    const data = await response.json();
    console.log('ChatSession status updated successfully:', data);
    setIsCancelProjectModalOpen(false); 
    handleSendMessage(socket, {sessionId:selectedChatSession._id, fromUserId: userInfo._id, fromRole:'system', content:`This project was canceled by ${selectedChatSession.clientName.split(' ')[0]}.\n\nHalf of the funds will be refunded to ${selectedChatSession.videographerName.split(' ')[0]}, and the remaining 50% will be released to ${selectedChatSession.videographerName.split(' ')[0]} for their time, planning, and preparation.\n\nWe appreciate everyone’s professionalism.`})
    return data;
  } catch (error) {
    console.error('Error updated chatSession statys:', error);
    throw error;
  }
}